/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CellClassActionsRepresentationFromJSON, CellClassActionsRepresentationToJSON, DataEntryLinkActionsRepresentationFromJSON, DataEntryLinkActionsRepresentationToJSON, DocumentClassActionsRepresentationFromJSON, DocumentClassActionsRepresentationToJSON, SheetRowClassActionsRepresentationFromJSON, SheetRowClassActionsRepresentationToJSON, TagClassActionsRepresentationFromJSON, TagClassActionsRepresentationToJSON, UserClassActionsRepresentationFromJSON, UserClassActionsRepresentationToJSON, } from './';
export function ClassActionsRepresentationFromJSON(json) {
    return ClassActionsRepresentationFromJSONTyped(json, false);
}
export function ClassActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentClassActions: DocumentClassActionsRepresentationFromJSON(json['documentClassActions']),
        tagClassActions: TagClassActionsRepresentationFromJSON(json['tagClassActions']),
        userClassActions: UserClassActionsRepresentationFromJSON(json['userClassActions']),
        cellClassActions: CellClassActionsRepresentationFromJSON(json['cellClassActions']),
        sheetRowClassActions: !exists(json, 'sheetRowClassActions')
            ? undefined
            : SheetRowClassActionsRepresentationFromJSON(json['sheetRowClassActions']),
        dataEntryLinkActions: DataEntryLinkActionsRepresentationFromJSON(json['dataEntryLinkActions']),
    };
}
export function ClassActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        documentClassActions: DocumentClassActionsRepresentationToJSON(value.documentClassActions),
        tagClassActions: TagClassActionsRepresentationToJSON(value.tagClassActions),
        userClassActions: UserClassActionsRepresentationToJSON(value.userClassActions),
        cellClassActions: CellClassActionsRepresentationToJSON(value.cellClassActions),
        sheetRowClassActions: SheetRowClassActionsRepresentationToJSON(value.sheetRowClassActions),
        dataEntryLinkActions: DataEntryLinkActionsRepresentationToJSON(value.dataEntryLinkActions),
    };
}
